import http from '../libs/axios';

const api = {
    createToken: (params) => http.post('Authorize/CreateToken', params),
    getUserProfile: () => http.post('ClientApi/MyProfile'),
    agreePrice: (params) => http.post('SourceGoods/ArgeePrice', params),
    getDictionary: (params) => http.post('Dict/DictSearch', params),
    createSourceGoods: (params) => http.post('SourceGoods/CreateSourceGoods', params),
    searchSourceGoods: (params) => http.post('SourceGoods/SearchSourceGoods', params),
    disabledSourceGoods: (params) => http.post('SourceGoods/DisabledSourceGoodsByID', params),
    searchOrders: (params) => http.post('ClientApi/SearchOrder2', params),
    getSourceGood: (params) => http.post('SourceGoods/GetSourceGoodsByID', params),
    getSourceGoodsModelList: (params) => http.post('SourceGoods/getSourceGoodsModelList', params),
    addOrUpdateSourceGoodsPrice: (params) => http.post('SourceGoods/AddOrUpdateSourceGoodsPrice', params),
    getWallets: (params) => http.get('ClientApi/MyWallet', params),
    saveWallet: (params) => http.post('ClientApi/SaveWallet', params),
    deleteWallet: (params) => http.post('ClientApi/DeleteWallet', params),
    savePassword: (params) => http.post('ClientApi/ModifyPassword', params),
    getYunDans: (params) => http.post('ClientApi/SearchOrder', params),
    sendSMSCode: (params) => http.post('Api/SendSMSCode', params),
    RegistUser: (params) => http.post('User/RegistUser', params),
    checkUserLoginName: (params) => http.post('User/CheckUserLoginName', params),
    checkUserStatus: () => http.post('ClientApi/CheckUserStatus'),
    saveProfileMore: (params) => http.post('ClientApi/SaveProfileMore', params),
    getAgreements: (params) => http.post('ClientApi/SearchAgreement', params),
    saveAgreement: (params) => http.post('ClientApi/SaveAgree', params),
    getCondition: (params) => http.post('Dict/GetDictByID', params),
    myCars: () => http.post('ClientApi/MyCars'),
    getCarById: (params) => http.post('ClientApi/GetCarById', params),
    saveCar: (params) => http.post('ClientApi/SaveCar', params),
    deleteCar: (params) => http.post('ClientApi/DeleteCar', params),
    
    //投诉建议
    searchComplaints:(params) => http.post('ClientApi/SearchComplaints', params),
    getComplaintsById:(params) => http.post('ClientApi/GetComplaintsById', params),
    addComplaints:(params) => http.post('ClientApi/AddComplaints', params),
    saveScore:(params) => http.post('ClientApi/SaveScore', params),

    //新闻
    searchNews:(params) => http.post('ClientApi/SearchNews', params),
    getNewsById:(params) => http.post('ClientApi/GetNewsById', params),
};
export default api;


// WEBPACK FOOTER //
// ./src/api/index.js